module.exports = function getResource(label, vars = []) {
    const resources = {
        checkboxContentIsModalCheckbox: 'J’accepte les modalités Beauty Insider. La récompense Rouge est valable pour *une transaction future uniquement*; elle *expire dans 90 jours* et sera envoyée par courriel dans les *24 heures*.',
        done: 'Terminé',
        youMustAcceptTermsConditions: 'Vous devez d’abord accepter les conditions.'
    };
    return resources[label];
};
